import { makeStyles, Modal, Typography } from '@material-ui/core'
import React from 'react'
import chirpLogo from '../../assets/images/chirpyest-text-logo.svg'
import { BREAKPOINTS, FONTS } from '../../constants'
import CHRButton from '../button'

interface DigitalMarketerShopModalProps {
  open: boolean
  onClose: () => void
  onCreateShareLink: () => void
}

/**
 * Shown in place of the retailer redirect whenever a Digital Marketer clicks "shop now" —
 * cashback is disabled for that segment, so this points them at the share-link tool instead.
 * Reused across every shop-now call site via `useDigitalMarketerShopGate`.
 */
const DigitalMarketerShopModal = ({
  open,
  onClose,
  onCreateShareLink,
}: DigitalMarketerShopModalProps) => {
  const classes = styles()
  return (
    <Modal open={open} onClose={onClose}>
      <div className={classes.modal}>
        <img src={chirpLogo} alt="logo" className={classes.logo} />
        <Typography variant="subtitle1" className={classes.message}>
          This action is currently unavailable for{' '}
          <strong className={classes.nowrap}>digital marketers</strong>.
          Instead, use the <strong>share link tool</strong>, which supports easy
          promotion and conversion tracking from the performance tab in your
          user profile.
        </Typography>
        <CHRButton
          label="create a share link"
          onClick={onCreateShareLink}
          customStyle={classes.cta}
        />
      </div>
    </Modal>
  )
}

const styles = makeStyles(theme => ({
  modal: {
    maxWidth: 480,
    width: '90%',
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
    position: 'absolute',
    boxShadow: theme.shadows[5],
    padding: 30,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 24,
    outline: 'none',
    [`@media (min-width: ${BREAKPOINTS.sm}px)`]: {
      padding: 40,
    },
  },
  logo: {
    width: '136px',
    height: '35px',
  },
  message: {
    textAlign: 'center',
    fontFamily: FONTS.Graphik.GraphikLight,
  },
  nowrap: {
    whiteSpace: 'nowrap',
  },
  cta: {
    width: '100%',
  },
}))

export default DigitalMarketerShopModal
